import React from "react";

export default () => {
  return (
    <>
      <p className="title">Color Codes</p>
      <p>
        <div className="color-block-container">
          <span className="color-block green source" /> Source Node
        </div>
        <div className="color-block-container">
          <span className="color-block blue" /> Unvisited Node
        </div>
        <div className="color-block-container">
          <span className="color-block green" /> Visited Node
        </div>
        <div className="color-block-container">
          <span className="color-block green destination" /> Destination Node
        </div>
        <div className="color-block-container">
          <span className="color-block yellow" /> Shortest Path Edge
        </div>
      </p>
    </>
  );
};
